import { useCarouselContext } from './carousel-context'
import { getDotIndexes, nextButtonDisabled, prevButtonDisabled } from './carousel-helpers'

export interface CarouselControlProps {
  cellAlign: 'left' | 'center' | 'right'
  slidesToScroll: number
  slidesToShow: number
  wrapAround: boolean

  /**
   * Current slide index
   */
  currentSlide: number

  /**
   * The indices for the paging dots
   */
  pagingDotsIndices: number[]

  /**
   * Go to a specific slide
   * @param targetIndex Index to go to
   */
  goToSlide: (targetIndex: number) => void

  /**
   * Whether the "next" button should be disabled or not
   */
  nextDisabled: boolean

  /**
   * Go to the next slide
   */
  nextSlide: () => void

  /**
   * Whether the "previous" button should be disabled or not
   */
  previousDisabled: boolean

  /**
   * Go to the previous slide
   */
  previousSlide: () => void

  /**
   * Total number of slides
   */
  slideCount: number
}

export function CarouselControl({
  children
}: {
  children?: React.ReactNode | ((args: CarouselControlProps) => React.ReactNode)
}) {
  const { slideCount, prevSlide, nextSlide, cellAlign, currentSlide, slidesToShow, wrapAround, slidesToScroll, goToSlide } =
    useCarouselContext()

  return (
    <>
      {typeof children === 'function'
        ? children({
            slideCount,
            previousSlide: prevSlide,
            previousDisabled: prevButtonDisabled({
              cellAlign,
              currentSlide,
              slidesToShow,
              wrapAround
            }),
            cellAlign,
            slidesToScroll,
            slidesToShow,
            wrapAround,
            currentSlide,
            pagingDotsIndices: getDotIndexes(slideCount, slidesToScroll, slidesToShow, wrapAround, cellAlign),
            goToSlide,
            nextDisabled: nextButtonDisabled({ cellAlign, currentSlide, slideCount, slidesToShow, wrapAround }),
            nextSlide: nextSlide
          })
        : children}
    </>
  )
}
